import { lazy } from "react";
import Layout from "../hoc/Layout";

const Evaluation = lazy(() => import("./containers/EvaluationTest"));

export const evaluationRoutes = [
  {
    path: "/evaluation-results",
    component: <Layout > <Evaluation />  </Layout>,
    exact: true
  },
]